import CAPS from "../constants/caps";

const unidadesPesquisa = [
  {
    "cnes": "9069321",
    "nomeCnes": "MMF da Colônia",
    "nomeGenerico": "MMF da Colônia"
  },
  {
    "cnes": "7746733",
    "nomeCnes": "MMF José Marti I",
    "nomeGenerico": "MMF da Grota I"
  },
  {
    "cnes": "2298872",
    "nomeCnes": "MMF José Marti II",
    "nomeGenerico": "MMF da Grota II"
  },
  {
    "cnes": "4645650",
    "nomeCnes": "MMF Professora Dra Satie Mizubuti",
    "nomeGenerico": "MMF do Holofote"
  },
  {
    "cnes": "0012939",
    "nomeCnes": "MMF Dr Ruy Carlos Decnop Celia Sanchez",
    "nomeGenerico": "MMF da Ilha da Conceicao"
  },
  {
    "cnes": "5985374",
    "nomeCnes": "MMF Dr Wilson de Oliveira",
    "nomeGenerico": "MMF da Ititioca"
  },
  {
    "cnes": "2298783",
    "nomeCnes": "MMF Julio Dias Gonzales",
    "nomeGenerico": "MMF da Leopoldina"
  },
  {
    "cnes": "2298775",
    "nomeCnes": "MMF Antônio Nico Lopez",
    "nomeGenerico": "MMF da Nova Brasília"
  },
  {
    "cnes": "9314237",
    "nomeCnes": "MMF Maria Tereza Barbosa Rangel \"Vó Tereza\"",
    "nomeGenerico": "MMF da Ponta da Areia"
  },
  {
    "cnes": "7504853",
    "nomeCnes": "MMF Dr Antônio Peçanha",
    "nomeGenerico": "MMF da Teixeira de Freitas"
  },
  {
    "cnes": "5985366",
    "nomeCnes": "MMF Vilma Espin",
    "nomeGenerico": "MMF da Vila Ipiranga"
  },
  {
    "cnes": "0012920",
    "nomeCnes": "MMF Mário Munhoz Monroe",
    "nomeGenerico": "MMF de Jurujuba"
  },
  {
    "cnes": "0012696",
    "nomeCnes": "MMF Dr Tobias Tostes Machado",
    "nomeGenerico": "MMF de Varzea das Mocas"
  },
  {
    "cnes": "7971249",
    "nomeCnes": "MMF Deputado José Sally",
    "nomeGenerico": "MMF do Baldeador"
  },
  {
    "cnes": "6644988",
    "nomeCnes": "MMF Dr Omar Marinho Vieira",
    "nomeGenerico": "MMF do Alarico"
  },
  {
    "cnes": "5985331",
    "nomeCnes": "MMF Salvador Allende",
    "nomeGenerico": "MMF do Atalaia"
  },
  {
    "cnes": "0012831",
    "nomeCnes": "MMF Professor Dr Barros Terra",
    "nomeGenerico": "MMF do Badu"
  },
  {
    "cnes": "8156964",
    "nomeCnes": "MMF Jardim das Paineiras",
    "nomeGenerico": "MMF Jardim das Paineiras"
  },
  {
    "cnes": "6746667",
    "nomeCnes": "MMF Raul Carlos Pareto Jr",
    "nomeGenerico": "MMF do Bernardino"
  },
  {
    "cnes": "2282224",
    "nomeCnes": "MMF Ernesto Che Guevara I",
    "nomeGenerico": "MMF do Cafuba I"
  },
  {
    "cnes": "2298805",
    "nomeCnes": "MMF Ernesto Che Guevara II",
    "nomeGenerico": "MMF do Cafuba II"
  },
  {
    "cnes": "5985358",
    "nomeCnes": "MMF Alberto Ricardo Hatin",
    "nomeGenerico": "MMF do Cafuba III"
  },
  {
    "cnes": "2298821",
    "nomeCnes": "MMF Haidee Santamaria",
    "nomeGenerico": "MMF do Cantagalo"
  },
  {
    "cnes": "2298813",
    "nomeCnes": "MMF Dr Aloisio Brazil",
    "nomeGenerico": "MMF do Caramujo"
  },
  {
    "cnes": "0012947",
    "nomeCnes": "MMF Frank Pais Garcia",
    "nomeGenerico": "MMF do Cavalao"
  },
  {
    "cnes": "9973877",
    "nomeCnes": "MMF Dr Cláudio do Amaral Júnior",
    "nomeGenerico": "MMF do Coronel Leoncio"
  },
  {
    "cnes": "0013013",
    "nomeCnes": "MMF Willian Soller",
    "nomeGenerico": "MMF do Engenho do Mato"
  },
  {
    "cnes": "0480894",
    "nomeCnes": "MMF Enoc Joaquim de Oliveira",
    "nomeGenerico": "MMF do Jacare"
  },
  {
    "cnes": "2298791",
    "nomeCnes": "MMF José Suares Blanco",
    "nomeGenerico": "MMF do Jonathas Botelho"
  },
  {
    "cnes": "7161093",
    "nomeCnes": "MMF João Sampaio",
    "nomeGenerico": "MMF do Maceió"
  },
  {
    "cnes": "3069184",
    "nomeCnes": "MMF Com Manoel Pineiro Lozada",
    "nomeGenerico": "MMF do Maravista"
  },
  {
    "cnes": "2282232",
    "nomeCnes": "MMF Carlos Rafael Rodriguez",
    "nomeGenerico": "MMF do Maritimos"
  },
  {
    "cnes": "9046836",
    "nomeCnes": "MMF Dr João Vasconcellos",
    "nomeGenerico": "MMF do Martins Torres"
  },
  {
    "cnes": "0013021",
    "nomeCnes": "MMF Jorge Luiz Camacho Rodrigues",
    "nomeGenerico": "MMF do Marui"
  },
  {
    "cnes": "9632298",
    "nomeCnes": "MMF Ítalo Gomes",
    "nomeGenerico": "MMF do Morro da Boa Vista"
  },
  {
    "cnes": "7596162",
    "nomeCnes": "MMF Faustino Perez",
    "nomeGenerico": "MMF do Morro do Ceu"
  },
  {
    "cnes": "0013064",
    "nomeCnes": "MMF Jesus Montane",
    "nomeGenerico": "MMF do Palacio"
  },
  {
    "cnes": "0012955",
    "nomeCnes": "MMF Abel Santamaria",
    "nomeGenerico": "MMF do Preventorio"
  },
  {
    "cnes": "9079696",
    "nomeCnes": "MMF do Sapê",
    "nomeGenerico": "MMF do Sapê"
  },
  {
    "cnes": "4747526",
    "nomeCnes": "MMF Dr José Luiz de O. Côrtes",
    "nomeGenerico": "MMF Serrão Juca Branco"
  },
  {
    "cnes": "2282216",
    "nomeCnes": "MMF José Antônio Echeverria Bianchi",
    "nomeGenerico": "MMF do Souza Soares"
  },
  {
    "cnes": "7312458",
    "nomeCnes": "MMF Tayssa Erminda Alves",
    "nomeGenerico": "MMF do Vicoso Jardim"
  },
  {
    "cnes": "0012963",
    "nomeCnes": "MMF Camilo Cienfuegos",
    "nomeGenerico": "MMF do Viradouro"
  },
  {
    "cnes": "0012971",
    "nomeCnes": "MMF Carlos Juan Finlay",
    "nomeGenerico": "MMF do Vital Brazil"
  },
  {
    "cnes": "8013004",
    "nomeCnes": "MMF Dr Abelardo Ramirez",
    "nomeGenerico": "MMF do Matapaca"
  },
  {
    "cnes": "3296598",
    "nomeCnes": "CAPS AD III Alcenir Veras",
    "nomeGenerico": "CAPS AD III Alcenir Veras"
  },
  {
    "cnes": "2293269",
    "nomeCnes": "CAPS Herbert de Souza",
    "nomeGenerico": "CAPS Herbert de Souza"
  },
  {
    "cnes": "2298856",
    "nomeCnes": "CAPS Martha e Dr. Jacinto",
    "nomeGenerico": "CAPS Martha e Dr. Jacinto"
  },
  {
    "cnes": "3708330",
    "nomeCnes": CAPS.CNES_3708330,
    "nomeGenerico": CAPS.CNES_3708330
  },
  /* {
    "cnes": "2854295",
    "nomeCnes": "Centro de Convivência e Cultura de Niterói",
    "nomeGenerico": "Centro de Convivência e Cultura de Niterói"
  }, */
];

export default unidadesPesquisa;
